// Utility function to parse API error responses
export const parseApiError = (error: any, fallbackMessage: string = 'Произошла ошибка. Попробуйте еще раз.'): string => {
  // Check if error has response data
  const responseData = error?.response?.data;
  
  if (!responseData) {
    return fallbackMessage;
  }

  // Case 1: detail is an array of error objects
  if (responseData.detail && Array.isArray(responseData.detail)) {
    const errorMessages = responseData.detail
      .filter((item: any) => item.msg) // Only items with msg field
      .map((item: any) => item.msg)
      .join(', ');
    
    return errorMessages || fallbackMessage;
  }

  // Case 2: detail is a string
  if (responseData.detail && typeof responseData.detail === 'string') {
    return responseData.detail;
  }

  // Case 3: message field
  if (responseData.message && typeof responseData.message === 'string') {
    return responseData.message;
  }

  // Case 4: error field
  if (responseData.error && typeof responseData.error === 'string') {
    return responseData.error;
  }

  // Fallback
  return fallbackMessage;
};

// Field-specific error mapping for better UX
export const getFieldDisplayName = (fieldPath: string[]): string => {
  const fieldMap: { [key: string]: string } = {
    'password': 'Пароль',
    'email': 'Email',
    'firstName': 'Имя',
    'lastName': 'Фамилия',
    'telegram': 'Telegram',
    'confirmPassword': 'Подтверждение пароля',
    'acceptTerms': 'Принятие условий'
  };

  // Get the last element of the path (actual field name)
  const fieldName = fieldPath[fieldPath.length - 1];
  return fieldMap[fieldName] || fieldName;
};

// Enhanced error parser that can show field-specific errors
export const parseApiErrorWithFields = (error: any, fallbackMessage: string = 'Произошла ошибка. Попробуйте еще раз.'): string => {
  // Check if error has response data
  const responseData = error?.response?.data;
  
  if (!responseData) {
    return fallbackMessage;
  }

  // Case 1: detail is an array of error objects with field info
  if (responseData.detail && Array.isArray(responseData.detail)) {
    const errorMessages = responseData.detail
      .filter((item: any) => item.msg) // Only items with msg field
      .map((item: any) => {
        const fieldName = item.loc && item.loc.length > 0 ? getFieldDisplayName(item.loc) : '';
        const message = item.msg;
        
        // If we have field info, format it nicely
        if (fieldName && !message.toLowerCase().includes(fieldName.toLowerCase())) {
          return `${fieldName}: ${message}`;
        }
        
        return message;
      })
      .join('\n');
    
    return errorMessages || fallbackMessage;
  }

  // Fallback to simple parser
  return parseApiError(error, fallbackMessage);
}; 